import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FlightChangeFlagModel } from './changed-flight-state.model';
import { Inject, Injectable } from '@angular/core';
import { SessionStorageDataModel, SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import { tap } from 'rxjs/operators';
import { TypedAction } from '@ngrx/store/src/models';
import * as ChangeFlightStateActions from '@store/changed-flight-state/changed-flight-state.actions';

@Injectable({
  providedIn: 'root',
})
export class ChangeFlightStateEffects {
  constructor(
    private actions$: Actions,
    @Inject(SessionStorageService) private _sessionStorage: SessionStorageService,
  ) {}

  changeFlightStateEffects$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ChangeFlightStateActions.setChangedFlightFlagState),
        tap((response: FlightChangeFlagModel & TypedAction<string>) => {
          if (this._sessionStorage.storage) {
            this._sessionStorage.storage.SESSION_STORAGE = {
              ...this._sessionStorage.storage.SESSION_STORAGE,
              wasFlightChangeConfirmed: response.wasFlightChangeConfirmed,
            } as SessionStorageDataModel;
          }
        }),
      ),
    { dispatch: false },
  );
}
